import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://legendconversion.com';
const SITE_NAME = 'Legend Conversion';
const DEFAULT_IMAGE = 'https://legendconversion.com/gallery/traveler-luxe/traveler-luxe-01.webp';

/**
 * Sets document title, meta description, OG tags, Twitter cards, and canonical URL.
 * Pass page-specific values; defaults are applied for missing fields.
 */
const usePageMeta = ({ title, description, image, path, type = 'website', keywords }) => {
  const location = useLocation();
  const currentPath = path || location.pathname;

  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Custom Luxury Van Conversions | Alvarado, TX`;
    const desc = description || 'Legend Conversion Corp transforms premium vans into luxury vehicles. Custom van builder in Alvarado, Texas with 31+ years of experience.';
    const img = image || DEFAULT_IMAGE;
    const url = `${BASE_URL}${currentPath}`;

    // Title
    document.title = fullTitle;

    // Helper to set or create a meta tag
    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Standard meta
    setMeta('name', 'title', fullTitle);
    setMeta('name', 'description', desc);
    if (keywords) setMeta('name', 'keywords', keywords);

    // Open Graph
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:image', img);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:site_name', SITE_NAME);

    // Twitter
    setMeta('property', 'twitter:title', fullTitle);
    setMeta('property', 'twitter:description', desc);
    setMeta('property', 'twitter:image', img);
    setMeta('property', 'twitter:url', url);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [title, description, image, currentPath, type, keywords]);
};

export default usePageMeta;
